import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import path from 'path';
import { isExternal } from '@/utils/validate';
import Item from './Item';
import AppLink from './Link';
export default {
  name: 'SidebarItem',
  components: {
    Item: Item,
    AppLink: AppLink
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    this.onlyOneChild = null;
    return {
      subExpanded: false
    };
  },
  computed: {
    sidebarActiveName: function sidebarActiveName() {
      var route = this.$route;
      if (route.query && route.query.route) {
        try {
          return JSON.parse(route.query.route).name;
        } catch (e) {
          return route.name;
        }
      }
      if (route.meta && route.meta.activeMenu) {
        return route.meta.activeMenu;
      }
      return route.name;
    },
    hasActiveDescendant: function hasActiveDescendant() {
      var _this = this;
      return this.item.children && this.item.children.length ? this.item.children.some(function (ch) {
        return !ch.hidden && _this.routeMatchesItem(ch);
      }) : false;
    }
  },
  watch: {
    hasActiveDescendant: {
      handler: function handler(val) {
        if (val) this.subExpanded = true;
      },
      immediate: true
    }
  },
  methods: {
    toggleSub: function toggleSub() {
      this.subExpanded = !this.subExpanded;
    },
    isLeafActive: function isLeafActive(routeItem) {
      if (!routeItem || !routeItem.name) return false;
      return routeItem.name === this.sidebarActiveName;
    },
    routeMatchesItem: function routeMatchesItem(routeItem) {
      var _this2 = this;
      if (this.isLeafActive(routeItem)) return true;
      if (routeItem.children && routeItem.children.length) {
        return routeItem.children.some(function (ch) {
          return !ch.hidden && _this2.routeMatchesItem(ch);
        });
      }
      return false;
    },
    hasOneShowingChild: function hasOneShowingChild() {
      var _this3 = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden) {
          return false;
        }
        _this3.onlyOneChild = item;
        return true;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: '',
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    resolvePath: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    }
  }
};